import React from 'react';
import AISparkleIcon from "../../../assets/AISparkleIcon";
import { formatRelativeTime } from "../../../helpers/DateHelpers.js";
import './AISummaryPanel.css';

const AISummaryPanel = ({ snapshot, onTriggerDawn, isOpen }) => {
  if (!isOpen) return null;
  
  if (!snapshot) {
    return (
      <div className="ai-panel ai-panel-empty">
        <AISparkleIcon sx={{ fontSize: 48, color: '#666' }} />
        <p>No Dawn summary available yet.</p>
        <button 
          className="ai-panel-button"
          onClick={onTriggerDawn}
        >
          Generate Summary
        </button>
      </div>
    );
  }
  
  const parsedSnapshot = typeof snapshot === 'string' 
    ? JSON.parse(snapshot) 
    : snapshot;
  
  const raw = parsedSnapshot.lastSnapshot?.raw || {};
  
  return (
    <div className="ai-panel">
      <div className="ai-panel-header">
        <AISparkleIcon 
  sx={{ fontSize: 52, color: '#A855F7' }} 
  style={{ border: '1px solid red' }}  // Add this to see the actual icon boundary
/>
        <div>
          <h3>Dawn AI Summary</h3>
          <span className="ai-panel-time">
            {formatRelativeTime(parsedSnapshot.lastSummaryGeneratedAt)}
          </span>
        </div>
      </div>
      
      <div className="ai-panel-summary">
        <p>{parsedSnapshot.lastSummary}</p>
      </div>
      
      <div className="ai-panel-metrics">
        <div className="ai-metric-card">
          <div className="ai-metric-label">Submissions</div>
          <div className="ai-metric-value">{raw.total_submissions || 0}</div>
          {raw.submissions_today > 0 && (
            <div className="ai-metric-delta">+{raw.submissions_today} today</div>
          )}
        </div>
        
        <div className="ai-metric-card">
          <div className="ai-metric-label">Reviews</div>
          <div className="ai-metric-value">
            {raw.complete_reviews || 0}/{raw.total_reviews || 0}
          </div>
          <div className="ai-metric-progress">
            {raw.total_reviews > 0 
              ? `${Math.round((raw.complete_reviews / raw.total_reviews) * 100)}%`
              : '0%'}
          </div>
        </div>
        
        <div className="ai-metric-card">
          <div className="ai-metric-label">Reviewers</div>
          <div className="ai-metric-value">{raw.total_reviewers || 0}</div>
          <div className="ai-metric-subtitle">
            {raw.reviewers_with_assignments || 0} active
          </div>
        </div>
      </div>
      
      <div className="ai-panel-footer">
        <button 
          className="ai-panel-button ai-panel-button--secondary"
          onClick={() => console.log('Full snapshot:', parsedSnapshot)}
        >
          View Details
        </button>
        <button 
          className="ai-panel-button ai-panel-button--primary"
          onClick={onTriggerDawn}
        >
          Refresh
        </button>
      </div>
    </div>
  );
};

export default AISummaryPanel;